import { every, isEmpty } from "@s-libs/micro-dash";

import {
  daysLeftCss,
  expirationDateCss,
  subscriptionsContainerCss,
  subscriptionTitleCss,
  subscriptionUnorderedListCss,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/UserProfileMenu/UserProfilePopout/PopoutSubscriptions/PopoutSubscriptions.styles";
import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";
import useUserLicenses from "@/users/useUserLicenses";
import {
  getDaysLeftInTrial,
  getLicensesLists,
  getSubscriptionsInformation,
} from "./PopoutSubscriptions.utils";

const PopoutSubscriptions = () => {
  const { data: user } = useUser();
  const {
    canViewTheirLicenses,
    hasPremiumLicense,
    hasNceTrialCampaign,
    hasAccessToLite,
    activeEssentialsLicense,
  } = getUserProperties(user, { shouldUseNewUserApi: false });

  const licenses = useUserLicenses();

  if (!canViewTheirLicenses) return null;

  const licensesLists = getLicensesLists(hasNceTrialCampaign, licenses);
  const [trials, subscriptions] = licensesLists;
  const daysLeftInTrial =
    !hasPremiumLicense &&
    !activeEssentialsLicense &&
    getDaysLeftInTrial(licenses, hasNceTrialCampaign);
  const subscriptionsInformation = getSubscriptionsInformation(
    hasPremiumLicense || activeEssentialsLicense ? subscriptions : trials,
  );

  if (isEmpty(subscriptionsInformation) && !hasAccessToLite) return null;

  return (
    <div css={subscriptionsContainerCss}>
      <div css={subscriptionTitleCss}>
        My subscriptions
        {daysLeftInTrial && daysLeftInTrial < 90 && (
          <span css={daysLeftCss}>{daysLeftInTrial} days left</span>
        )}
      </div>

      <ul css={subscriptionUnorderedListCss}>
        {hasAccessToLite && every(licensesLists, isEmpty) && (
          <li data-qa-selector="global-nav-newsela-lite-subscription">
            Newsela Lite
          </li>
        )}
        <>
          {subscriptionsInformation?.map((subscription, index) => (
            <li
              key={index}
              data-qa-selector={`global-nav-${subscription.product.toLowerCase().replace(" ", "-")}`}
            >
              {subscription.product}
              {!hasPremiumLicense &&
                !activeEssentialsLicense &&
                subscription.expirationDate && (
                  <p css={expirationDateCss}>
                    Expires on <strong>{subscription.expirationDate}</strong>
                  </p>
                )}
            </li>
          ))}
        </>
      </ul>
    </div>
  );
};

PopoutSubscriptions.displayName = "PopoutSubscriptions";
export { PopoutSubscriptions };
